var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"btn btn-link p-0",attrs:{"role":"button"},on:{"click":function($event){return _vm.rollDice(_vm.dataDiceNotation)}}},[_vm._t("default"),_vm._v(" "),_c('font-awesome-icon',{attrs:{"icon":"dice","size":"lg"}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }